import axios from 'axios'
import Qs from 'qs'

const baseURL = 'https://personalization-qa.phrasee.co'
const accountToken =
  '2825b5a74bcac4e3811a24f80a0f413c54303aabeb43b7b18afa4c3ce58e4df7fa9ac921932554146ef55cd0a40e36d6d79b8752409832e8849f5ab80ae48aa4fdba6474008a7b06abc563cd9a0aa57ed21767d4d68905000be9e4b6550321a41ee1b744cd86f5f9ac01a34fdf34fd23'

const personalizationApi = axios.create({
  baseURL,
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: 'comma' })
  },
  headers: {
    Authorization: `Bearer ${accountToken}`,
  },
})

export const getRecommendation = async ({
  productCategory,
  productName,
}: {
  productCategory: string
  productName: string | undefined
}): Promise<{ variant_text: string }> => {
  const result = await personalizationApi.get<{ variant_text: string }>(
    '/personalized_variant',
    {
      params: {
        product_category: productCategory,
        replacer_variable: 'PRODUCT_NAME',
        product_name: productName,
        replacer_value: productName,
        campaign_id: '628e17eebbdbc20007147664',
        project_id: 'currys_test',
        recipient_id: Math.random().toString(36).slice(2),
        replacer_default: 'Mr',
        delivery_id: Math.random().toString(36).slice(2),
        channel: 'email',
        use_case: 'Abandon Cart',
        'customer&value': 'high',
      },

      headers: {
        Authorization:
          'Bearer 2825b5a74bcac4e3811a24f80a0f413c54303aabeb43b7b18afa4c3ce58e4df7fa9ac921932554146ef55cd0a40e36d6d79b8752409832e8849f5ab80ae48aa4fdba6474008a7b06abc563cd9a0aa57ed21767d4d68905000be9e4b6550321a41ee1b744cd86f5f9ac01a34fdf34fd23',
      },
    }
  )

  return result.data
}
